'use client';
import React, { useEffect, useState } from 'react';
import PriceUnit from './PriceUnit';
import { useMemo } from 'react';

export default function Price({ price, large = false }) {
  const percent = useMemo(() => {
    if (price && price.regular !== price.sale) {
      return Math.round(((price.regular - price.sale) / price.regular) * 100);
    }
    return 0;
  }, [price]);

  return (
    <>
      {price ? (
        <>
          {price.sale != price.regular ? (
            <div className="price-with-discount">
              <div className="regular-price flex text-xs md:text-sm ">
                <span className="line-through text-gray-100 ">
                  {price.regular.toLocaleString('fa-IR')}
                </span>
                {percent != 0 && (
                  <span className="onsale bg-color-discount text-white rounded-md py-0.5 px-1.5 text-tiny md:text-sm mr-2 flex items-center">
                    %{percent}
                  </span>
                )}
              </div>
              <div
                className={`sale-price flex pt-2 text-color-price ${
                  large ? 'text-xl font-bold' : 'text-sm md:text-base'
                }   items-center`}
              >
                <PriceUnit price={price.sale} />
              </div>
            </div>
          ) : (
            <div
              className={`price-without-discount mx-auto flex ${
                large ? 'text-base font-bold' : 'text-sm'
              }  md:text-base min-h-[57px] items-center`}
            >
              <div className="flex items-center">
                <PriceUnit price={price.regular} />
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="text-xs flex items-center  min-h-[57px] ">
            برای اطلاع از قیمت تماس بگیرید
          </div>
        </>
      )}
    </>
  );
}
